import * as React from "react";
const SvgFiRrLeaf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaf_svg__a)">
      <path
        fill="#062147"
        d="M23.119.872a2.98 2.98 0 0 0-2.405-.857C17.92.285 8.528 1.448 4.9 5.072a9.93 9.93 0 0 0-.671 13.28l-3.94 3.94a1 1 0 0 0 1.414 1.415l3.94-3.94a9.93 9.93 0 0 0 13.284-.667c3.677-3.677 4.8-13.041 5.06-15.823a2.99 2.99 0 0 0-.868-2.405m-5.6 16.81a7.925 7.925 0 0 1-10.44.657l9.633-9.632a1 1 0 0 0-1.415-1.414l-9.636 9.632a7.924 7.924 0 0 1 .657-10.44c2.509-2.507 9.427-3.985 14.589-4.48A1 1 0 0 1 22 3.088c-.5 5.387-1.942 12.049-4.486 14.594z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaf_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeaf;
